export const TEST_ID = {
  contentHubViewerPublic: 'contentHubViewerPublic',
};
